import { tv } from 'tailwind-variants';
import { focusStyles } from '../../styles/focusStyles.esm.js';
import { INPUT_VARIANT } from '../../utils/constant.esm.js';

const SelectDropdownTriggerStyles = tv({
    slots: {
        container: `
      iris:flex
      iris:flex-col-reverse
      iris:gap-(--comp-space-gap-input)
    `,
        innerContainer: `
      iris:pointer-events-auto
      iris:flex
      iris:flex-col
      iris:items-start
      iris:justify-start
    `,
        trigger: `
      iris:peer
      iris:group
      iris:border-(--comp-color-border-input-rest)
      iris:py-(--comp-space-padding-select-vertical)
      iris:pr-(--comp-space-padding-select-right)
      iris:pl-(--comp-space-padding-select-left)
      iris:duration-(--comp-motion-duration-input)
      iris:duration-(--comp-motion-duration-text-input)
      iris:focus-visible:rounded-xs
      iris:focus-visible:border-(--comp-color-border-input-active)
      iris:active:border-(--comp-color-border-input-active)
      iris:data-placeholder:text-(--comp-color-content-input-placeholder-rest)
    `,
        labelInner: `
      iris:absolute
      iris:top-(--base-space-px-8)
      iris:left-[var(--comp-size-border-input)]
      iris:px-(--comp-space-padding-input-horizontal)
      iris:font-(family-name:--comp-type-font-input-inner-label)
      iris:text-(length:--comp-type-size-input-inner-label)
      iris:leading-(--comp-type-leading-input-inner-label)
      iris:font-(--comp-type-weight-input-inner-label)!
      iris:tracking-(--comp-type-tracking-input-inner-label)
      iris:transition-all
      iris:duration-(--comp-motion-duration-text-input)
      iris:ease-(--comp-motion-easing-text-input)
      iris:peer-focus:top-(--base-space-px-8)
      iris:peer-focus:translate-y-0
      iris:peer-focus:text-(length:--comp-type-size-input-inner-label)
      iris:data-[hasvalue=false]:top-1/2
      iris:data-[hasvalue=false]:-translate-y-1/2
      iris:data-[hasvalue=false]:text-(length:--comp-type-size-input-value)

     
      `,
        labelBase: `
      iris:w-fit
      iris:cursor-default
      iris:font-(family-name:--comp-type-font-input-label)
      iris:font-(--comp-type-weight-input-label)!
      iris:text-(--comp-color-content-input-label-rest)
      iris:hover:text-(--comp-color-content-input-label-hover)
      iris:focus-visible:text-(--comp-color-content-input-label-active)
      iris:active:text-(--comp-color-content-input-label-active)
    `,
        icon: `
      iris:h-8
      iris:w-8
      iris:text-(--comp-color-content-input-icon-rest)
      iris:hover:text-(--comp-color-content-input-icon-hover)
      iris:focus-visible:text-(--comp-color-content-input-icon-active)
    `,
        content: `
      iris:w-(--radix-select-trigger-width)
      iris:bg-white
      iris:shadow-lg
    `,
        viewport: `
      iris:bg-red
      iris:w-(--radix-select-trigger-width)
      iris:p-2
    `,
        inlineMsg: ``,
    },
    variants: {
        variant: {
            [INPUT_VARIANT.Outer]: {
                trigger: "",
                labelBase: `
          iris:text-(length:--comp-type-size-input-label)
          iris:leading-(--comp-type-leading-input-label)
        `,
            },
            [INPUT_VARIANT.Inner]: {
                trigger: `
          iris:leading-(--comp-type-leading-input-value)
          iris:data-placeholder:text-(--comp-color-content-input-label-rest)
        `,
                labelBase: `
          iris:text-(length:--comp-type-size-input-inner-label)
          iris:leading-(--comp-type-leading-input-inner-label)
        `,
            },
        },
        placeholder: {},
        inverse: {
            true: {
                content: ``,
                labelBase: `
          iris:text-(--comp-color-content-input-label-inverse-rest)
          iris:group-focus-visible:text-(--comp-color-content-input-label-inverse-active)
          iris:group-active:text-(--comp-color-content-input-label-inverse-active)
          iris:peer-focus-visible:text-(--comp-color-content-input-label-inverse-active)
          iris:peer-active:text-(--comp-color-content-input-label-inverse-active)
          iris:peer-data-[state=error]:text-(--comp-color-content-input-label-inverse-error)
          iris:hover:text-(--comp-color-content-input-label-inverse-hover)
          iris:peer-focus-visible:hover:text-(--comp-color-content-input-label-inverse-active)
          iris:peer-active:hover:text-(--comp-color-content-input-label-inverse-active)
          iris:peer-data-[state=error]:hover:text-(--comp-color-content-input-label-inverse-error)
          iris:focus-visible:text-(--comp-color-content-input-label-inverse-active)
          iris:peer-data-[state=error]:focus-visible:text-(--comp-color-content-input-label-inverse-error)
          iris:active:text-(--comp-color-content-input-label-inverse-active)
          iris:peer-data-[state=error]:active:text-(--comp-color-content-input-label-inverse-error)
        `,
                trigger: `
          iris:focus-visible:border-(--comp-color-border-input-inverse-active)
          ${focusStyles.inverse}
          iris:active:border-(--comp-color-border-input-inverse-active)
          iris:data-placeholder:text-(--comp-color-content-input-placeholder-inverse-rest)

          iris:data-[state=error]:border-(--comp-color-border-input-inverse-error)
          iris:data-[state=error]:text-(--comp-color-content-input-value-inverse-error)
          iris:data-[state=error]:hover:border-(--comp-color-border-input-inverse-error)
          iris:data-[state=error]:focus-visible:border-(--comp-color-border-input-inverse-error)
          iris:data-[state=error]:active:border-(--comp-color-border-input-inverse-error)
          iris:data-[state=error]:data-placeholder:text-(--comp-color-content-input-placeholder-inverse-error)
        `,
                icon: `
          iris:text-(--comp-color-content-input-icon-inverse-rest)
          iris:group-data-[state=error]:text-(--comp-color-content-input-icon-inverse-error)
          iris:hover:text-(--comp-color-content-input-icon-inverse-hover)
          iris:group-data-[state=error]:hover:text-(--comp-color-content-input-icon-inverse-error)
          iris:focus-visible:text-(--comp-color-content-input-icon-inverse-active)
          iris:group-data-[state=error]:focus-visible:text-(--comp-color-content-input-icon-inverse-error)
        `,
                inlineMsg: `
          iris:data-[state=error]:text-(--comp-color-content-input-helper-inverse-error)
          iris:data-[state=error]:hover:text-(--comp-color-content-input-helper-inverse-error)
          iris:data-[state=error]:focus-visible:text-(--comp-color-content-input-helper-inverse-error)
        `,
            },
            false: {
                labelBase: `
          iris:peer-focus-visible:text-(--comp-color-content-input-label-active)
          iris:peer-active:text-(--comp-color-content-input-label-active)
          iris:peer-data-[state=error]:text-(--comp-color-content-input-label-error)
          iris:peer-focus-visible:hover:text-(--comp-color-content-input-label-active)
          iris:peer-active:hover:text-(--comp-color-content-input-label-active)
          iris:peer-data-[state=error]:hover:text-(--comp-color-content-input-label-error)
          iris:peer-data-[state=error]:focus-visible:text-(--comp-color-content-input-label-error)
          iris:peer-data-[state=error]:active:text-(--comp-color-content-input-label-error)
        `,
                trigger: `
          ${focusStyles.default}
          iris:data-[state=error]:border-(--comp-color-border-input-error)
          iris:data-[state=error]:text-(--comp-color-content-input-value-error)
          iris:data-[state=error]:hover:border-(--comp-color-border-input-error)
          iris:data-[state=error]:focus-visible:border-(--comp-color-border-input-error)
          iris:data-[state=error]:active:border-(--comp-color-border-input-error)
          iris:data-[state=error]:data-placeholder:text-(--comp-color-content-input-placeholder-error)
        `,
                inlineMsg: `
          iris:data-[state=error]:text-(--comp-color-content-input-helper-error)
          iris:data-[state=error]:hover:text-(--comp-color-content-input-helper-error)
          iris:data-[state=error]:focus-visible:text-(--comp-color-content-input-helper-error)
        `,
                icon: `
          iris:group-data-[state=error]:text-(--comp-color-content-input-icon-error)
          iris:group-data-[state=error]:hover:text-(--comp-color-content-input-icon-error)
          iris:group-data-[state=error]:focus-visible:text-(--comp-color-content-input-icon-error)
        `,
            },
        },
        disabled: {
            true: {
                trigger: `
          iris:cursor-not-allowed
          iris:hover:border-(--comp-color-border-input-rest)
          iris:focus-visible:border-(--comp-color-border-input-rest)
          iris:focus-visible:ring-0
          iris:focus-visible:ring-offset-0
          iris:active:border-(--comp-color-border-input-rest)
        `,
                labelBase: `
          iris:text-(--comp-color-content-input-label-disabled)
          iris:peer-active:text-(--comp-color-content-input-label-disabled)
          iris:hover:text-(--comp-color-content-input-label-disabled)
          iris:focus-visible:text-(--comp-color-content-input-label-disabled)
          iris:active:text-(--comp-color-content-input-label-disabled)
        `,
                inlineMsg: "iris:opacity-(--sem-opacity-interactive-disabled)",
            },
            false: {},
        },
        error: {
            true: {
                labelBase: `
          iris:text-(--comp-color-content-input-label-error)
          iris:hover:text-(--comp-color-content-input-label-error)
          iris:focus-visible:text-(--comp-color-content-input-label-error)
          iris:active:text-(--comp-color-content-input-label-error)
        `,
                trigger: `
          iris:border-(--comp-color-border-input-error)
          iris:text-(--comp-color-content-input-value-error)
          iris:hover:border-(--comp-color-border-input-error)
          iris:focus-visible:border-(--comp-color-border-input-error)
          iris:active:border-(--comp-color-border-input-error)
          iris:data-placeholder:text-(--comp-color-content-input-placeholder-error)
        `,
                inlineMsg: `
          iris:text-(--comp-color-content-input-helper-error)
          iris:hover:text-(--comp-color-content-input-helper-error)
          iris:focus-visible:text-(--comp-color-content-input-helper-error)
        `,
                icon: `
          iris:text-(--comp-color-content-input-icon-error)
          iris:hover:text-(--comp-color-content-input-icon-error)
          iris:focus-visible:text-(--comp-color-content-input-icon-error)
        `,
            },
            false: {},
        },
    },
    compoundVariants: [
        {
            disabled: true,
            inverse: true,
            class: {
                trigger: `
          iris:border-(--comp-color-border-input-inverse-rest)
          iris:text-(--comp-color-content-input-value-inverse-rest)
          iris:hover:border-(--comp-color-border-input-inverse-rest)
          iris:focus-visible:border-(--comp-color-border-input-inverse-rest)
          iris:active:border-(--comp-color-border-input-inverse-rest)
        `,
                labelBase: `
          iris:text-(--comp-color-content-input-label-inverse-rest)
          iris:peer-active:text-(--comp-color-content-input-label-inverse-rest)
          iris:hover:text-(--comp-color-content-input-label-inverse-rest)
          iris:focus-visible:text-(--comp-color-content-input-label-inverse-rest)
          iris:active:text-(--comp-color-content-input-label-inverse-rest)
        `,
            },
        },
        {
            isFocus: true,
            inverse: true,
            class: {
                labelBase: `
          iris:text-(--comp-color-content-input-label-inverse-active)
          iris:hover:text-(--comp-color-content-input-label-inverse-active)
        `,
            },
        },
        {
            isError: true,
            inverse: true,
            class: {
                labelBase: `
          iris:text-(--comp-color-content-input-label-inverse-error)
          iris:hover:text-(--comp-color-content-input-label-inverse-error)
          iris:focus-visible:text-(--comp-color-content-input-label-inverse-error)
          iris:active:text-(--comp-color-content-input-label-inverse-error)
        `,
                trigger: `
          iris:border-(--comp-color-border-input-inverse-error)
          iris:text-(--comp-color-content-input-value-inverse-error)
          iris:hover:border-(--comp-color-border-input-inverse-error)
          iris:focus-visible:border-(--comp-color-border-input-inverse-error)
          iris:active:border-(--comp-color-border-input-inverse-error)
          iris:data-placeholder:text-(--comp-color-content-input-placeholder-inverse-error)
        `,
                inlineMsg: `
          iris:text-(--comp-color-content-input-helper-inverse-error)
          iris:hover:text-(--comp-color-content-input-helper-inverse-error)
          iris:focus-visible:text-(--comp-color-content-input-helper-inverse-error)
        `,
                icon: `
          iris:text-(--comp-color-content-input-icon-inverse-error)
          iris:hover:text-(--comp-color-content-input-icon-inverse-error)
          iris:focus-visible:text-(--comp-color-content-input-icon-inverse-error)
        `,
            },
        },
    ],
    defaultVariants: {
        variant: "outer",
        disabled: false,
        inverse: true,
    },
});

export { SelectDropdownTriggerStyles as default };
